import Trainer from '@/containers/trainer/Home';

import { ROUTE_TRAINER_HOME } from '@/router/names';

export default [
    {
        path: '/trainer',
        name: ROUTE_TRAINER_HOME,
        component: Trainer,
        meta: {
            trainer_auth: true,
            title: '我',
        },
    },
];



// WEBPACK FOOTER //
// ./src/router/trainer.js